<template>
  <div class="xur-popup">
    <img
      class="xur-popup__image"
      src="/images/altcraft_popup/popupFront.jpg"
      alt="">

    <h1 class="xur-popup__header">
      Allow notifications and never miss Xur!
    </h1>

    <p class="xur-popup__text">
      Be the first to know the new location of Xur and the items he's selling
    </p>

    <button
      class="button xur-popup__button xur-popup__button--decline transition--color-bg"
      @click="closePopup">
      Don`t allow
    </button>

    <button
      class="button xur-popup__button xur-popup__button--sub transition--color-bg"
      @click="subPush">
      Turn on notifications
    </button>
  </div>
</template>

<script>
import AltcraftPush from 'Root/drivers/altcraftPush';
import altcraftScriptLoader from 'Root/mixins/altcraftScriptLoader';
import googleTagAnalytics from 'Root/drivers/googleTagAnalytics';
import AltcraftPopupModel from 'Models/AltcraftPopupModel';
import localStorageManager from 'Root/helpers/localStorageManager';

export default {
  name: 'AltcraftPopupXur',

  mixins: [
    altcraftScriptLoader,
  ],

  props: {
    email: {
      type: String,
      required: false,
      default: null,
    },
  },

  methods: {
    closePopup() {
      this.$vuedals.close(false);
    },

    async subPush() {
      await this.loadAltcraftPush();

      this.$vuedals.close(true);

      const pushService = new AltcraftPush(new window.AKPush());
      await pushService.subscribe(AltcraftPopupModel.TARGET_FIELD.XUR, this.email).catch(() => 0);

      googleTagAnalytics.emitXurPopup('push');

      localStorageManager.setFlag(AltcraftPopupModel.LOCALSTORAGE.XUR_PUSH_SUBSCRIBED, true);
    },
  },
};
</script>

<style lang="scss">
.mobile-panel-popup.xur-popup__wrapper {
  background-color: $color--basic-black;
}
</style>

<style lang="scss" scoped>
.xur-popup {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.xur-popup__image {
  width: 100%;
  height: 160px;
  object-fit: contain;
  margin-bottom: 16px;
}

.xur-popup__header {
  width: 100%;
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 16px;
  text-align: center;
}

.xur-popup__text {
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 16px;
  text-align: center;
  color: $color--basic-dark-gray;
}

.xur-popup__button {
  padding: 12px;
  width: 100%;
  position: relative;
}

.xur-popup__button--decline {
  background: $color--basic-menu;
  margin-bottom: 16px;
}

.xur-popup__button--decline:hover {
  background: $color--additional-menu;
}

.xur-popup__button--sub {
  background: $color--basic-green;
}

.xur-popup__button--sub:hover {
  background: $color--basic-lime;
}

@media screen and #{$screen-more-or-640} {
  .xur-popup__image {
    height: 240px;
    margin-bottom: 25px;
  }

  .xur-popup__header {
    font-size: 25px;
    margin-bottom: 24px;
  }

  .xur-popup__text {
    font-size: 15px;
    margin-bottom: 24px;
  }

  .xur-popup__button {
    font-size: 15px;
    padding: 15px;
    flex-grow: 1;
  }

  .xur-popup__button--decline {
    margin-bottom: 0;
    margin-right: 16px;
    width: calc(50% - 8px);
  }

  .xur-popup__button--sub {
    width: calc(50% - 8px);
  }
}
</style>
